import { render, staticRenderFns } from "./exhibition-act-add.vue?vue&type=template&id=6b5e4e22&scoped=true&"
import script from "./exhibition-act-add.vue?vue&type=script&lang=js&"
export * from "./exhibition-act-add.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-act-add.vue?vue&type=style&index=0&id=6b5e4e22&scoped=true&lang=scss&"
import style1 from "./exhibition-act-add.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e4e22",
  null
  
)

export default component.exports